import React, { useState } from 'react';
import './body.css';
import DigimonCard from './DigimonCard';
const Body = (props) =>{
    let digimons = props.digimons;
    const [buscaNome,setBuscaNome] = useState('');
    let digimonsFiltrados = digimons.filter((digimon)=> digimon.name.toLowerCase().includes(buscaNome.toLowerCase()));
    return(
        <>
        <div className='header-box'>
        <h1>Digidex</h1>
        <input type="text" value={buscaNome} onChange={(e)=>setBuscaNome(e.target.value)} placeholder="Buscar digimon pelo nome"/>
        </div>
        <div className='main-box'>
        {digimonsFiltrados.map((digimon)=>(
        <DigimonCard digimon={digimon}/>
         ))
        }
        </div>
        </>
    )
}

export default Body;